module.factory('bankToAddService', function() {

  var bank = '';
  var accounts = [];

  var service = {
    save: save,
    get: get,
    bank: bank,
    saveAccount: saveAccount,
    getAccounts: getAccounts,
    accounts: accounts,
    resetAccounts: resetAccounts
  };

  return service;

  function save(bank) {
    this.bank = bank;
  }

  function get() {
    return this.bank;
  }

  function saveAccount(account) {
    this.accounts.push(account);
  }

  function getAccounts() {
    return this.accounts;
  }

  function resetAccounts() {
    this.accounts = [];
  }

});
